import React from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";

const Breadcrumbs = ({ breadcrumbNameMap }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const isDynamicId = (segment) => {
    return /^[0-9a-f]{24}$/.test(segment) || /^[0-9]+$/.test(segment);
  };

  const specialSegments = [
    "add-inspection",
    "welding-gas-form",
    "welding-machine-calibration",
    "welding-wpq-inspection",
    "iso-weld-log",
    "project-report",
    "ncr-report"
  ];

  const isNonClickableSegment = (to) => {
    return (
      to.includes("view-inspector-details") || to.includes("edit-inspector")
    );
  };

  const isNonClickableProject = (to) => {
    return (
      to.includes("view-project-details") || to.includes("edit-manage-project")
    );
  };

  return (
    <nav className="text-base mb-4">
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const breadcrumbLabel = breadcrumbNameMap[value];
        const nextSegment = pathnames[index + 1];

        if (isDynamicId(value) || !breadcrumbLabel) {
          return null;
        }

        const isMaster = value === "master";
        const isViewProjectDetails =
          to === "/manage-project/view-project-details";
        const hasSpecialSegment = pathnames.some((segment) =>
          specialSegments.includes(segment)
        );
        const disableViewProjectDetails =
          isViewProjectDetails && hasSpecialSegment;

        return last ? (
          <span key={to} className="text-[#ABABAB]">
            {breadcrumbLabel}
          </span>
        ) : (
          <span key={to}>
            {isMaster ||
            isNonClickableSegment(to) ||
            disableViewProjectDetails ||
            isNonClickableProject(to) ||
            isDynamicId(nextSegment) ? (
              <span className="text-[#ABABAB] mr-2">{breadcrumbLabel}</span>
            ) : (
              <RouterLink
                to={to}
                className="text-[#ABABAB] hover:underline mr-2"
              >
                {breadcrumbLabel}
              </RouterLink>
            )}
            {!last && breadcrumbNameMap[nextSegment] && (
              <span className="mx-1 text-[#ABABAB]">{">"}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
